<template>
  <v-tooltip
      bottom
      color="primary"
      open-delay="300"
      :open-on-click="false"
      :open-on-focus="false"
      :open-on-hover="text != null"
  >
  <template v-slot:activator="{ on, attrs }">
    <span
      :draggable="draggable"
      @dragstart="onStartDrag($event)"
      v-bind="attrs"
      v-on="on"
  >
      <v-avatar
          class="hover handle my-0 mx-0 py-0 px-0"
          :color="getBadgeTHTColor()"
          size="20"
          @click="onClickBadge($event)"
      >
        <v-avatar
            :color="getBadgeSMDColor()"
            size="12"
        >
          <span class="hover black-text text-caption" :class="getBadgeTextColorClass()">{{ content }}</span>
        </v-avatar>
      </v-avatar>
  </span>
  </template>
    <span>{{ text }}</span>
</v-tooltip>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import {mapFields} from "vuex-map-fields";

export default {
  name: 'BatchRunBadge',
  props: ['text', 'item', 'draggable', 'content'],

  data() {
    return {
      hover: false,
      hoverFlag: false,
    }
  },

  components: {},

  computed: {
    ...mapFields('BatchRunWeek', ['active_batch_run', 'smd_start_plan', 'smd_end_plan',
      'tht_start_plan', 'tht_end_plan', 'smd_end', 'tht_end', 'lt_mat', 'lt_min']),
  },

  methods: {
    onClickBadge(event) {
      console.log('Click badge', this.item)
      this.active_batch_run = this.item
      this.smd_start_plan = this.item.smd_start_plan
      this.smd_end_plan = this.item.smd_end_plan
      this.tht_start_plan = this.item.tht_start_plan
      this.tht_end_plan = this.item.tht_end_plan
      this.smd_end = this.item.smd_end
      this.tht_end = this.item.tht_end
      this.lt_mat = this.item.lt_mat
      this.lt_min = this.item.lt_min
      event.stopPropagation()
    },
    onStartDrag(event) {
      console.log('onStartDrag', event, this.item.id)
      event.dataTransfer.setData('itemID', this.item.id)
      this.active_batch_run = null
      this.smd_start_plan = null
      this.smd_end_plan = null
      this.tht_start_plan = null
      this.tht_end_plan = null
      this.smd_end = null
      this.tht_end = null
      this.lt_mat = null
      this.lt_min = null
    },
    getBadgeSMDColor() {
      // console.log('getBadgeSMDColor', this.item.title, this.item.smd, this.item.smd_end)
      if (this.item.smd > 0) {
        if (this.item.smd_end)
          return 'smd_light_color'
        else
          return 'smd_color'
      }
      return 'grey lighten-1'
    },
    getBadgeTHTColor() {
      // console.log('getBadgeTHTColor', this.item.title, this.item.smd, this.item.smd_end)
      if (this.item.tht > 0) {
        if (this.item.tht_end)
          return 'tht_light_color'
        else
          return 'tht_color'
      }
      return 'grey lighten-1'
    },
    getBadgeTextColorClass() {
      return 'black-text'
    },
  },

  mounted() {
  },
}
</script>

<style scoped lang="scss">
.drag-el {
  //background-color: #fff;
  //margin-bottom: 10px;
  //padding: 10px;
}

.hover-badge {
  z-index: 10;
}

.hover {
  z-index: 1;
}

.black-text {
  color: black;
}

.white-text {
  color: white;
}

* {
  font-weight: bold;
}
</style>